import { pipe, toLower } from "ramda";

export const stripDiacritics = (str = "") =>
  str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

export const normalizeString = pipe(String, toLower, stripDiacritics);

export const isString = (value) => typeof value === "string";
